<template>
  <div id="event-info">
    <portal to="action-buttons" v-if="$store.state.event.event">
      <ul class="navbar-nav ml-md-auto">
        <li class="nav-item">
          <event-links></event-links>
        </li>
      </ul>
    </portal>

    <div class="content-wrapper" v-if="form" style="max-width: 1140px;">
      <div class="col-md-12" style="">
        <div class="card" style="padding:0px; padding-bottom:15px;">
          <div class="profile-cover">
            <div class="profile-cover-img" :style="'background-image: url(' + $imageus + form.image + '?width=1120&height=500&mode=cover);'">
              <el-upload :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=eventCover&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" :on-success="coverSuccess" :on-progress="coverProgress" class="upload-cover" ref="upload">
                <div class="el-upload__tip" slot="tip">{{ $t("eventInfo.cover.description") }}</div>
                <el-button slot="trigger" size="small" type="primary" circle icon="el-icon-upload"></el-button>
              </el-upload>
            </div>
          </div>

          <div class="custom-profile-bar media align-items-center text-center text-md-left flex-column flex-md-row m-0">
            <div class="mr-md-3 mb-2 mb-md-0">
              <div class="profile-thumb">
                <img :src="$imageus + form.logo + '?width=200&height=200&mode=contain'" style="background: #ececec; cursor: default" class="border-white" width="120" height="120" alt />
                <el-upload :onProgress="logoProgress" class="upload-logo" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=eventLogo&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" :on-success="logoSuccess">
                  <el-button size="small" type="primary" circle icon="el-icon-upload"></el-button>
                  <div class="el-upload__tip" slot="tip">{{ $t("eventInfo.logo.description") }}</div>
                </el-upload>
              </div>
            </div>

            <div class="media-body custom-media-text">
              <h1 class="mb-0 line-clamp-1">{{ form.title }}</h1>
              <span class="d-block">
                <i class="fas fa-calendar"></i>
                {{ $moment($store.state.event.event.startDate).format(dateFormatEvent($store.state.event.event.dateFormat)) + " " + ($store.state.event.event.startTime != null ? $store.state.event.event.startTime : "") }}
                <i class="fas fa-long-arrow-alt-right"></i>
                {{ $moment($store.state.event.event.endDate).format(dateFormatEvent($store.state.event.event.dateFormat)) + " " + ($store.state.event.event.endTime != null ? $store.state.event.event.endTime : "") }}
              </span>
              <span style="margin-top:3px;" class="d-block" v-if="form.location.venue != null && form.location.venue != ''">
                <i class="fas fa-map-marker-alt"></i>
                <div class="line-clamp-1">{{ form.location.venue }}</div>
              </span>
              <span style="margin-top:3px" class="d-block">
                <i class="fas fa-globe-americas"></i>
                <b>{{ form.timezone }}</b>
              </span>
            </div>

            <div class="ml-md-3 mt-3">
              <div class="custom-event-switch">
                <el-switch style="display: block;" :value="form.settings.isPublished" active-color="#268EA6" inactive-color="#D6D9D9" @change="publishEvent" :inactive-text="!form.settings.isPublished ? $t('event.buttons.notPublished') : $t('event.buttons.published')"></el-switch>
              </div>
            </div>
          </div>

          <el-tabs :tab-position="'left'">
            <el-tab-pane :label="$t('eventInfo.about.title')">
              <el-row :gutter="10" class="px-3">
                <el-col :span="24" class="info-card">
                  <div class="header">
                    <div class="title">
                      {{ $t("eventInfo.about.informations") }}
                      <span>{{ $t("eventInfo.about.informationsMsg") }}</span>
                    </div>
                    <div class="actions"></div>
                  </div>

                  <el-row :gutter="10">
                    <el-col :span="20">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.about.eventName") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.about.eventNameMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-input v-model="form.title" :class="$inputError('title', validationErrors)"></el-input>
                        <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.about.color") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.about.colorMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-color-picker v-model="form.color"></el-color-picker>
                        <span class="error">{{ $errorMessage("color", validationErrors) }}</span>
                      </div>
                    </el-col>

                    <el-col :span="16" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.about.language") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.about.languageMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-select multiple v-model="form.languages">
                          <el-option v-for="lang in getEnums.find(x => x.title == 'EventLanguage').enums" :key="lang.key" :label="lang.displayName" :value="lang.key"></el-option>
                        </el-select>
                        <span class="error">{{ $errorMessage("languages", validationErrors) }}</span>
                      </div>
                    </el-col>
                    <el-col :span="8" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.about.timezone") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.about.timezoneMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-select v-model="form.timezone" filterable>
                          <el-option v-for="(time, index) in allTimeZones" :key="index + time.id" :label="time.title" :value="time.id"></el-option>
                        </el-select>
                        <span class="error">{{ $errorMessage("timezone", validationErrors) }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>

                <el-col :span="24" class="info-card mt-3">
                  <div class="header">
                    <div class="title">
                      {{ $t("eventInfo.about.date") }}
                      <span>{{ $t("eventInfo.about.dateMsg") }}</span>
                    </div>
                    <div class="actions"></div>
                  </div>

                  <el-row :gutter="10">
                    <el-col :span="6" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.about.stardDate") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.about.stardDateMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-date-picker :format="datePickerDisplayFormat()" v-model="form.startDate" :clearable="false" :default-time="['12:00:00']" class="w-100" type="date" :placeholder="$t('datetime.setDate')"></el-date-picker>
                        <span class="error">{{ $errorMessage("startDate", validationErrors) }}</span>
                      </div>
                    </el-col>
                    <el-col :span="6" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.about.startTime") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.about.startTimeMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-time-select style="width:100%;" v-model="form.startTime" :placeholder="$t('datetime.setTime')" :picker-options="{ start: '00:00', step: '00:05', end: '23:59' }"></el-time-select>
                        <span class="error">{{ $errorMessage("startTime", validationErrors) }}</span>
                      </div>
                    </el-col>
                    <el-col :span="6" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.about.endDate") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.about.endDateMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <!-- <input type="date" v-model="form.endDate"> -->
                        <el-date-picker :format="datePickerDisplayFormat()" v-model="form.endDate" :timezone-offset="0" :clearable="false" class="w-100" :default-time="['12:00:00']" type="date" :placeholder="$t('datetime.setDate')"></el-date-picker>
                        <span class="error">{{ $errorMessage("endDate", validationErrors) }}</span>
                      </div>
                    </el-col>
                    <el-col :span="6" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.about.endTime") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.about.endTimeMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-time-select style="width:100%;" v-model="form.endTime" :placeholder="$t('datetime.setTime')" :picker-options="{ start: '00:00', step: '00:05', end: '23:59' }"></el-time-select>
                        <span class="error">{{ $errorMessage("endTime", validationErrors) }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>

                <el-col :span="24" class="info-card mt-3">
                  <div class="header">
                    <div class="title">
                      {{ $t("eventInfo.about.localization") }}
                      <span>{{ $t("eventInfo.about.localizationMsg") }}</span>
                    </div>
                    <div class="actions"></div>
                  </div>

                  <el-row :gutter="10">
                    <el-col :span="12" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.about.dateFormat") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.about.dateFormatMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-select v-model="form.dateFormat">
                          <el-option v-for="date in getEnums.find(x => x.title == 'DateFormat').enums" :key="date.key" :label="date.displayName" :value="date.key"></el-option>
                        </el-select>
                        <span class="error">{{ $errorMessage("dateFormat", validationErrors) }}</span>
                      </div>
                    </el-col>
                    <el-col :span="12" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.about.timeFormat") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.about.timeFormatMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-select v-model="form.timeFormat">
                          <el-option v-for="time in getEnums.find(x => x.title == 'TimeFormat').enums" :key="time.key" :label="time.displayName" :value="time.key"></el-option>
                        </el-select>
                        <span class="error">{{ $errorMessage("timeFormat", validationErrors) }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>

                <el-col :span="24" class="info-card mt-3">
                  <div class="header">
                    <div class="title">
                      {{ $t("eventInfo.about.content") }}
                      <span>{{ $t("eventInfo.about.contentMsg") }}</span>
                    </div>
                    <div class="actions"></div>
                  </div>

                  <el-row :gutter="10">
                    <el-col :span="12" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.about.eventType") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.about.eventTypeMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-select v-model="form.type">
                          <el-option v-for="eventtype in getEnums.find(x => x.title == 'EventType').enums" :key="eventtype.key" :label="eventtype.displayName" :value="eventtype.key"></el-option>
                        </el-select>
                        <span class="error">{{ $errorMessage("type", validationErrors) }}</span>
                      </div>
                    </el-col>
                    <el-col :span="12" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.about.category") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.about.categoryMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-select v-model="form.categoryId">
                          <el-option v-for="category in getEventCategories" :key="category.id" :label="category.title" :value="category.id"></el-option>
                        </el-select>
                        <span class="error">{{ $errorMessage("categoryId", validationErrors) }}</span>
                      </div>
                    </el-col>
                    <el-col :span="24" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.about.about") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.about.aboutMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <quill-editor v-model="form.about" :options="editorOption" ref="myQuillEditor" @ready="onEditorReady($event)"></quill-editor>
                        <span class="error">{{ $errorMessage("about", validationErrors) }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="24" class="mt-2 d-flex justify-content-end">
                  <!-- <el-button size="mini" type="default" icon="el-icon-refresh" round>Değişiklikleri Geri Al </el-button> -->
                  <el-button size="medium" type="primary" @click="saveBasic" :loading="loading == 'saveBasic'">{{ $t("eventInfo.about.save") }}</el-button>
                </el-col>
              </el-row>
            </el-tab-pane>

            <el-tab-pane :label="$t('eventInfo.location.title')">
              <el-row :gutter="10" class="px-3">
                <el-col :span="24" class="info-card">
                  <div class="header">
                    <div class="title">
                      {{ $t("eventInfo.location.addressTitle") }}
                      <span>{{ $t("eventInfo.location.addressTitleMsg") }}</span>
                    </div>
                    <div class="actions"></div>
                  </div>

                  <el-row :gutter="10">
                    <el-col :span="24">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.location.venue") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.location.venueMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-input @change="venueChanged = true" v-model="form.location.venue" :class="$inputError('location.Venue', validationErrors)"></el-input>
                        <span class="error">{{ $errorMessage("location.Venue", validationErrors) }}</span>
                      </div>
                    </el-col>
                    <el-col :span="24" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.location.address") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.location.addressMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-input @change="addressChanged = true" type="textarea" v-model="form.location.address" :rows="4" :class="$inputError('location.Address', validationErrors)"></el-input>
                        <span class="error">{{ $errorMessage("location.Address", validationErrors) }}</span>
                      </div>
                    </el-col>
                    <el-col :span="12" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.location.country") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.location.countryMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-input v-model="form.location.country" :class="$inputError('location.Country', validationErrors)"></el-input>
                        <span class="error">{{ $errorMessage("location.Country", validationErrors) }}</span>
                      </div>
                    </el-col>
                    <el-col :span="12" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.location.city") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.location.cityMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-input v-model="form.location.city" :class="$inputError('location.City', validationErrors)"></el-input>
                        <span class="error">{{ $errorMessage("location.City", validationErrors) }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>

                <el-col :span="24" class="info-card mt-3">
                  <div class="header">
                    <div class="title">
                      {{ $t("eventInfo.location.location") }}
                      <span>{{ $t("eventInfo.location.locationMsg") }}</span>
                    </div>
                    <div class="actions"></div>
                  </div>

                  <el-row :gutter="10">
                    <el-col :span="24">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("eventInfo.location.mapLocation") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.location.mapLocationMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <div class="position-relative">
                          <gmap-autocomplete class="introInput" @place_changed="placeChanged" :key="form.location.latitude" :placeholder="$t('event.textbox.search')">
                            <template v-slot:input="slotProps">
                              <v-text-field style="width: 100%" id="addressInput" prepend-inner-icon="place" ref="input" v-on:listeners="slotProps.listeners" v-on:attrs="slotProps.attrs"></v-text-field>
                            </template>
                          </gmap-autocomplete>
                          <i class="fas fa-trash cursor-pointer position-absolute text-danger delete-icon" style="right:1rem;top:12px;" @click="resetMap" v-if="form.location.longtitude != null || form.location.latitude != null"></i>
                        </div>

                        <span class="error">{{ $errorMessage("location.Latitude", validationErrors) }}</span>
                      </div>
                    </el-col>
                    <el-col :span="24" class="mt-3">
                      <div class="registerform-input-container">
                        <GmapMap :center="getLatLng" :zoom="7" v-if="form.location.latitude" map-type-id="terrain" style="width: 100%; height: 300px; border-radius: 8px; overflow: hidden;" ref="mapRef">
                          <GmapMarker :key="form.location.latitude" :position="getLatLng" :clickable="true" :draggable="true" @dragend="setCenter" ref="marker" />
                        </GmapMap>
                        <span class="error">{{ $errorMessage("location.Longtitude", validationErrors) }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>

                <el-col :span="24" class="info-card mt-3">
                  <div class="header">
                    <div class="title">
                      {{ $t("eventInfo.contact.contact") }}
                      <span>{{ $t("eventInfo.contact.contactMsg") }}</span>
                    </div>
                    <div class="actions"></div>
                  </div>

                  <el-row :gutter="10">
                    <el-col :span="24" class="contact-container" :class="{ passive: !form.organizator.mobilePhoneIsActive }">
                      <i class="fas fa-mobile-alt"></i>
                      <el-input v-model="form.organizator.mobilePhone"></el-input>
                      <el-switch v-model="form.organizator.mobilePhoneIsActive"></el-switch>
                    </el-col>
                    <el-col :span="24" class="contact-container" :class="{ passive: !form.organizator.phoneNumberIsActive }">
                      <i class="el-icon-phone"></i>
                      <el-input v-model="form.organizator.phoneNumber"></el-input>
                      <el-switch v-model="form.organizator.phoneNumberIsActive"></el-switch>
                    </el-col>
                    <el-col :span="24" class="contact-container" :class="[{ passive: !form.organizator.emailIsActive }, $inputError('organizator.Email', validationErrors)]">
                      <i class="fas fa-envelope"></i>
                      <el-input v-model="form.organizator.email" :placeholder="validationErrors.find(x => x.key == 'organizator.Email') ? validationErrors.find(x => x.key == 'organizator.Email').value : ''"></el-input>
                      <el-switch v-model="form.organizator.emailIsActive"></el-switch>
                    </el-col>
                  </el-row>
                </el-col>

                <el-col :span="24" class="info-card mt-3">
                  <div class="header">
                    <div class="title">
                      {{ $t("eventInfo.social.social") }}
                      <span>{{ $t("eventInfo.social.socialMsg") }}</span>
                    </div>
                    <div class="actions"></div>
                  </div>

                  <el-row :gutter="10">
                    <el-col :span="24" class="contact-container" :class="{ passive: !form.socialMedia.twitterIsACtive }">
                      <i class="fab fa-twitter socials twitter-color"></i>
                      <el-input v-model="form.socialMedia.twitter">
                        <template slot="prepend">
                          https://www.twitter.com/
                        </template>
                      </el-input>
                      <el-switch v-model="form.socialMedia.twitterIsACtive"></el-switch>
                    </el-col>
                    <el-col :span="24" class="contact-container" :class="{ passive: !form.socialMedia.linkedInIsActive }">
                      <i class="fab fa-linkedin socials linkedin-color"></i>
                      <el-input v-model="form.socialMedia.linkedIn">
                        <template slot="prepend">
                          https://www.linkedin.com/
                        </template>
                      </el-input>
                      <el-switch v-model="form.socialMedia.linkedInIsActive"></el-switch>
                    </el-col>
                    <el-col :span="24" class="contact-container" :class="{ passive: !form.socialMedia.facebookIsActive }">
                      <i class="fab fa-facebook-square socials facebook-color"></i>
                      <el-input v-model="form.socialMedia.facebook">
                        <template slot="prepend">
                          https://www.facebook.com/
                        </template>
                      </el-input>
                      <el-switch v-model="form.socialMedia.facebookIsActive"></el-switch>
                    </el-col>
                    <el-col :span="24" class="contact-container" :class="{ passive: !form.socialMedia.instagramIsActive }">
                      <i class="fab fa-instagram socials instagram-color"></i>
                      <el-input v-model="form.socialMedia.instagram">
                        <template slot="prepend">
                          https://www.instagram.com/
                        </template>
                      </el-input>
                      <el-switch v-model="form.socialMedia.instagramIsActive"></el-switch>
                    </el-col>
                    <el-col :span="24" class="contact-container" :class="{ passive: !form.socialMedia.youtubeIsActive }">
                      <i class="fab fa-youtube socials youtube-color"></i>
                      <el-input v-model="form.socialMedia.youtube">
                        <template slot="prepend">
                          https://www.youtube.com/
                        </template>
                      </el-input>
                      <el-switch v-model="form.socialMedia.youtubeIsActive"></el-switch>
                    </el-col>
                    <el-col :span="24" class="contact-container" :class="{ passive: !form.socialMedia.websiteIsActive }">
                      <i class="fas fa-link socials link-color"></i>
                      <el-input v-model="form.socialMedia.website">
                        <template slot="prepend">
                          https://
                        </template>
                      </el-input>
                      <el-switch v-model="form.socialMedia.websiteIsActive"></el-switch>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="24" class="mt-2 d-flex justify-content-end">
                  <!-- <el-button size="mini" type="default" icon="el-icon-refresh" round>Değişiklikleri Geri Al </el-button> -->
                  <el-button size="medium" type="primary" @click="saveContact" :loading="loading == 'saveContact'">{{ $t("eventInfo.settings.save") }}</el-button>
                </el-col>
              </el-row>
            </el-tab-pane>

            <el-tab-pane :label="$t('eventInfo.settings.title')">
              <el-row class="px-3">
                <el-col :span="24" class="info-card">
                  <div class="header">
                    <div class="title">
                      {{ $t("eventInfo.settings.settings") }}
                      <span>{{ $t("eventInfo.settings.settingsMsg") }}</span>
                    </div>
                    <div class="actions"></div>
                  </div>

                  <el-row :gutter="10">
                    <el-col :span="24">
                      <div class="custom-set-container" :class="form.settings.isAutoCheckInEnabled ? 'sactive' : ''">
                        <div class="custom-set-inner">
                          <i class="fas" :class="form.settings.isAutoCheckInEnabled ? 'fa-map-marker-alt' : 'fa-ban'"></i>
                          <div class="custom-set-info">
                            <label>
                              {{ $t("eventInfo.settings.autoCheckin.title") }}
                              <!-- <el-tooltip content="Content" placement="bottom">
                                <i class="el-icon-info"></i>
                              </el-tooltip> -->
                            </label>
                            <span>{{ $t("eventInfo.settings.autoCheckin.description") }}</span>
                          </div>
                        </div>
                        <div class="custom-set-actions fend">
                          <el-button size="mini" type="primary" round v-if="false" @click="openUpgradeDialog">{{ $t("components.dashboard.content.upgrade") }}</el-button>
                          <el-switch v-else v-model="form.settings.isAutoCheckInEnabled"></el-switch>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="24" class="mt-2">
                      <div class="custom-set-container" :class="form.settings.isAutoCheckInIntervalEnabled ? 'sactive' : ''">
                        <div class="custom-set-inner">
                          <i class="fas" :class="form.settings.isAutoCheckInIntervalEnabled ? 'fa-clock' : 'fa-ban'"></i>
                          <div class="custom-set-info">
                            <template v-if="$i18n.locale == 'tr'">
                              <label>
                                Süreli check-in
                              </label>
                              <div style=" border-radius: 8px;">
                                Katılımcıları
                                <el-input-number size="mini" v-model="form.settings.autoCheckInIntervalMinutes" :disabled="!form.settings.isAutoCheckInIntervalEnabled" style="margin-right: 5px"></el-input-number>
                                dakika sonra ilk giriş kontrolünde tekrar check-in yap.
                              </div>
                            </template>
                            <template v-else>
                              <label>
                                Periodic check-in
                              </label>
                              <div style=" border-radius: 8px;">
                                Enable attendees re-check-in after
                                <el-input-number size="mini" v-model="form.settings.autoCheckInIntervalMinutes" :disabled="!form.settings.isAutoCheckInIntervalEnabled" style="margin-right: 5px"></el-input-number>
                                minutes from their first check-ins.
                              </div>
                            </template>
                          </div>
                        </div>
                        <div class="custom-set-actions fend">
                          <el-switch v-model="form.settings.isAutoCheckInIntervalEnabled"></el-switch>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <!-- <el-col :span="24" class="info-card mt-3">
                  <div class="header">Çeviri desteği</div>
                  <el-row :gutter="10">
                    <el-col :span="24">
                      <div class="custom-set-container" :class="form.settings.isAutoTranslateEnabled ? 'sactive' : 'spassive'">
                        <div class="custom-set-inner">
                          <i class="fas" :class="form.settings.isAutoTranslateEnabled ? 'fa-globe-asia' : 'fa-ban'"></i>
                          <div class="custom-set-info">
                            <label
                              >Support multi-language with Google translate
                              <el-tooltip content="Content" placement="bottom">
                                <i class="el-icon-info"></i>
                              </el-tooltip>
                            </label>
                            <span>Expand your event's reach by communicating with your participants in their preferred language by activating Google Translate's automated translation.</span>
                          </div>
                        </div>
                        <div class="custom-set-actions fend">
                          <el-switch v-model="form.settings.isAutoTranslateEnabled"></el-switch>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col> -->
                <el-col :span="24" class="info-card mt-3">
                  <div class="header">
                    <div class="title">
                      {{ $t("eventInfo.settings.interaction.interaction") }}
                      <span>{{ $t("eventInfo.settings.interaction.interactionMsg") }}</span>
                    </div>
                    <div class="actions"></div>
                  </div>

                  <el-row :gutter="10">
                    <el-col :span="24">
                      <div class="custom-set-container" :class="form.settings.isProgramRatesRestricted ? 'swaiting' : ''">
                        <div class="custom-set-inner">
                          <i class="fas" :class="form.settings.isProgramRatesRestricted ? 'fa-star' : 'fa-ban'"></i>
                          <div class="custom-set-info">
                            <label>
                              {{ $t("eventInfo.settings.interaction.restrictSession") }}
                              <!-- <el-tooltip content="Content" placement="bottom">
                                <i class="el-icon-info"></i>
                              </el-tooltip> -->
                            </label>
                            <span>{{ $t("eventInfo.settings.interaction.restrictSessionMsg") }}</span>
                          </div>
                        </div>
                        <div class="custom-set-actions fend">
                          <el-switch v-model="form.settings.isProgramRatesRestricted"></el-switch>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="24" class="mt-2">
                      <div class="custom-set-container" :class="form.settings.isAttendeeProfilesRestricted ? 'swaiting' : ''">
                        <div class="custom-set-inner">
                          <i class="fas" :class="form.settings.isAttendeeProfilesRestricted ? 'fa-user-secret' : 'fa-ban'"></i>
                          <div class="custom-set-info">
                            <label>
                              {{ $t("eventInfo.settings.interaction.profileView") }}
                              <!-- <el-tooltip content="Content" placement="bottom">
                                <i class="el-icon-info"></i>
                              </el-tooltip> -->
                            </label>
                            <span>{{ $t("eventInfo.settings.interaction.profileViewMsg") }}</span>
                          </div>
                        </div>
                        <div class="custom-set-actions fend">
                          <el-switch v-model="form.settings.isAttendeeProfilesRestricted"></el-switch>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="24" class="mt-2">
                      <div class="custom-set-container" :class="form.settings.isB2BNetworkingEnabled ? 'sactive' : ''">
                        <div class="custom-set-inner">
                          <i class="fas" :class="form.settings.isB2BNetworkingEnabled ? 'fa-handshake' : 'fa-ban'"></i>
                          <div class="custom-set-info">
                            <label>
                              B2B Matchmaking
                              <!-- <el-tooltip content="Content" placement="bottom">
                                <i class="el-icon-info"></i>
                              </el-tooltip> -->
                            </label>
                            <span>
                              {{ $t("b2b.text") }}
                            </span>
                          </div>
                        </div>
                        <div class="custom-set-actions fend">
                          <el-button size="mini" type="primary" round v-if="false" @click="openUpgradeDialog">{{ $t("components.dashboard.content.upgrade") }}</el-button>
                          <el-switch v-model="form.settings.isB2BNetworkingEnabled" v-else></el-switch>
                        </div>
                        <transition name="el-fade-in" mode="out-in">
                          <div class="custom-b2b-area" v-if="form.settings.isB2BNetworkingEnabled">
                            <div class="b2b-area-list">
                              <div class="b2b-item">
                                <div class="b2b-title">{{ $t("b2b.appointmentMinute") }}</div>
                                <el-select v-model="form.settings.b2BNetworkingInterval">
                                  <el-option v-for="n in 24" :key="n" :label="n * 5 + ' ' + $t('b2b.minute')" :value="n * 5"></el-option>
                                </el-select>
                              </div>
                              <div class="b2b-item">
                                <div class="b2b-title">{{ $t("b2b.start_time") }}</div>
                                <el-time-select
                                  v-model="form.settings.b2BStartTime"
                                  :picker-options="{
                                    start: '00:15',
                                    step: '00:15',
                                    end: '23:55'
                                  }"
                                  placeholder="Select time"
                                ></el-time-select>
                              </div>
                              <div class="b2b-item">
                                <div class="b2b-title">{{ $t("b2b.end_time") }}</div>
                                <el-time-select
                                  v-model="form.settings.b2BEndTime"
                                  :picker-options="{
                                    start: '00:15',
                                    step: '00:15',
                                    end: '23:55'
                                  }"
                                  placeholder="Select time"
                                ></el-time-select>
                              </div>
                              <!-- <div class="b2b-item">
                                <div class="b2b-title">B2B günleri</div>
                                <el-select>
                                  <el-option v-for="item in form.settings.b2BDates" :key="item.id"></el-option>
                                </el-select>
                              </div> -->
                            </div>
                          </div>
                        </transition>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="24" class="mt-2 d-flex justify-content-end">
                  <!-- <el-button size="mini" type="default" icon="el-icon-refresh" round>Değişiklikleri Geri Al TODO LAR 5x* </el-button> -->
                  <el-button size="medium" type="primary" @click="saveGeneral" :loading="loading == 'saveGeneral'">{{ $t("eventInfo.settings.save") }}</el-button>
                </el-col>
              </el-row>
            </el-tab-pane>

            <el-tab-pane :label="$t('eventInfo.modules.title')">
              <el-row class="px-3">
                <el-col :span="24" class="info-card ">
                  <div class="header">
                    <div class="title">
                      {{ $t("eventInfo.modules.modules") }}
                      <span>{{ $t("eventInfo.modules.modulesMsg") }}</span>
                    </div>
                    <div class="actions">
                      <el-button-group>
                        <el-tooltip class="" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                          <el-button type="default" size="mini" icon="fas fa-life-ring" round></el-button>
                        </el-tooltip>
                        <el-button type="primary" size="mini" icon="fas fa-plus" round :loading="loading == 'newAppModule'" @click="newAppModule">{{ $t("eventInfo.modules.addModule") }}</el-button>
                      </el-button-group>
                    </div>
                  </div>

                  <!-- show warning if data has changes and needs to be saved -->
                  <el-row v-if="isModulesDataChanged">
                    <el-col :span="24" class="mt-2 d-flex justify-content-between align-items-center flex-row-reverse">
                      <!-- <el-button size="mini" type="default" icon="el-icon-refresh" round>Değişiklikleri Geri Al </el-button> -->
                      <el-button size="medium" type="primary" @click="saveModules" :loading="loading == 'saveModules'">{{ $t("eventInfo.modules.save") }}</el-button>
                      <div class="el-message el-message--warning inner-alert">
                        <i class="el-message__icon el-icon-warning"></i>
                        <p class="el-message__content">{{ $t("commonMessages.changesNeedsToSave") }}</p>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row :gutter="10">
                    <el-col :span="24">
                      <div class="custom-grid-table-header modules-grid-head">
                        <span><i v-show="loading == 'loadingList'" class="el-icon-loading"></i></span>
                        <span>{{ $t("eventInfo.modules.module") }}</span>
                        <span class="text-center">{{ $t("eventInfo.modules.view") }}</span>
                        <span></span>
                      </div>
                      <draggable class="modules-grid-items-container" :list="form.modules" tag="div" handle=".el-icon-s-grid" v-bind="dragOptions" @update="onModulesDragUpdate">
                        <div class="item" :class="{ passive: !module.isActive }" v-for="(module, moduleIndex) in form.modules" :key="moduleIndex + 'module-items'">
                          <div><i class="el-icon-s-grid burger"></i></div>
                          <div class="modules-item-title">
                            <div class="modules-item-left">
                              <i class="fas fa-ribbon" v-if="module.name == 'Sponsors'"></i>
                              <i class="fas fa-microphone" v-if="module.name == 'Speakers'"></i>
                              <i class="fas fa-images" v-if="module.name == 'Gallery'"></i>
                              <i class="fas fa-user-friends" v-if="module.name == 'Participants'"></i>
                              <i class="fas fa-heart" v-if="module.name == 'SocialHub'"></i>
                              <i class="fas fa-calendar" v-if="module.name == 'Program'"></i>
                              <i class="fas fa-map-marker-alt" v-if="module.name == 'AreaMaps'"></i>
                              <i class="fas fa-question-circle" v-if="module.name == 'QuestionLibrary'"></i>
                              <i class="fas fa-folder" v-if="module.name == 'Documents'"></i>
                              <i class="fas fa-store" v-if="module.name == 'stands'"></i>
                              <i class="fas fa-video" v-if="module.name == 'livestreams'"></i>
                              <i class="fas fa-handshake" v-if="module.name == 'networking'"></i>
                              <i class="fas fa-link" v-if="module.name == '' || module.name == undefined"></i>
                            </div>
                            <div class="modules-item-right">
                              <div class="modules-item-head">
                                {{ $i18n.locale === "en" ? module.title : module.titleTr }}
                              </div>
                              <div class="modules-item-sub-head">
                                {{ $t("eventInfo.modules.publishMsg", [$i18n.locale === "en" ? module.title.toLowerCase() : module.titleTr]) }}
                              </div>
                            </div>
                          </div>
                          <div class="text-center">
                            <el-switch v-model="module.isActive"></el-switch>
                          </div>

                          <div class="d-flex justify-content-end">
                            <el-tooltip class="" effect="dark" :content="$t('buttonGeneral.edit')" placement="top">
                              <el-button
                                type="primary"
                                size="mini"
                                circle
                                icon="fas fa-pen"
                                @click="
                                  updateEventModuleIndex = moduleIndex;
                                  updateEventForm = JSON.parse(JSON.stringify(module));
                                  modalVisible2 = true;
                                "
                              ></el-button>
                            </el-tooltip>
                            <div v-if="module.isCustom" class="ml-1">
                              <el-tooltip class="" effect="dark" :content="$t('buttonGeneral.delete')" placement="top">
                                <el-popconfirm @confirm="deleteModuleItem(moduleIndex)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                                  <el-button type="danger" slot="reference" size="mini" circle icon="fas fa-trash" :loading="loading == 'deleteModuleItem-' + moduleIndex"></el-button>
                                </el-popconfirm>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                      </draggable>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="24" class="mt-2 d-flex justify-content-between align-items-center flex-row-reverse">
                  <!-- <el-button size="mini" type="default" icon="el-icon-refresh" round>Değişiklikleri Geri Al </el-button> -->
                  <el-button size="medium" type="primary" @click="saveModules" :loading="loading == 'saveModules'">{{ $t("eventInfo.modules.save") }}</el-button>
                  <div v-if="isModulesDataChanged" class="el-message el-message--warning inner-alert">
                    <i class="el-message__icon el-icon-warning"></i>
                    <p class="el-message__content">{{ $t("commonMessages.changesNeedsToSave") }}</p>
                  </div>
                </el-col>
              </el-row>
            </el-tab-pane>

            <el-tab-pane :label="$t('eventInfo.widgets.title')">
              <el-row class="px-3">
                <el-col :span="24" class="info-card ">
                  <div class="header">
                    <div class="title">
                      {{ $t("eventInfo.widgets.widgets") }}
                      <span>{{ $t("eventInfo.widgets.widgetsMsg") }}</span>
                    </div>
                    <div class="actions"></div>
                  </div>
                  <upgrade-overlay height="300px" v-if="false"></upgrade-overlay>
                  <el-row :gutter="10" v-else>
                    <el-col :span="24" class="widget-item" @click.native="openWidget('registration-form')">
                      <div class="widget-icon">
                        <i class="fas fa-pen"></i>
                      </div>
                      <div class="widget-head">
                        <div class="widget-title">{{ $t("eventInfo.widgets.registration") }}</div>
                        <div class="widget-subtitle">{{ $t("eventInfo.widgets.registrationMsg") }}</div>
                      </div>
                       <i class="fas fa-arrow-right"></i>
                    </el-col>

                    <el-col @click.native="openWidget('event-program')" :span="24" class="widget-item mt-2">
                      <div class="widget-icon">
                        <i class="fas fa-calendar"></i>
                      </div>
                      <div class="widget-head">
                        <div class="widget-title">{{ $t("eventInfo.widgets.program") }}</div>
                        <div class="widget-subtitle">{{ $t("eventInfo.widgets.programMsg") }}</div>
                      </div>
                      <i class="fas fa-arrow-right"></i>
                    </el-col>

                    <el-col @click.native="openWidget('speakers')" :span="24" class="widget-item mt-2">
                      <div class="widget-icon">
                        <i class="fas fa-microphone"></i>
                      </div>
                      <div class="widget-head">
                        <div class="widget-title">{{ $t("eventInfo.widgets.speakers") }}</div>
                        <div class="widget-subtitle">{{ $t("eventInfo.widgets.speakersMsg") }}</div>
                      </div>
                      <i class="fas fa-arrow-right"></i>
                    </el-col>

                    <el-col @click.native="openWidget('sponsors')" :span="24" class="widget-item mt-2">
                      <div class="widget-icon">
                        <i class="fas fa-ribbon"></i>
                      </div>
                      <div class="widget-head">
                        <div class="widget-title">{{ $t("eventInfo.widgets.sponsor") }}</div>
                        <div class="widget-subtitle">{{ $t("eventInfo.widgets.sponsorMsg") }}</div>
                      </div>
                      <i class="fas fa-arrow-right"></i>
                    </el-col>

                    <el-col @click.native="openWidget('expo')" :span="24" class="widget-item mt-2">
                      <div class="widget-icon">
                        <i class="fas fa-store"></i>
                      </div>
                      <div class="widget-head">
                        <div class="widget-title">{{ $t("eventInfo.widgets.foyer") }}</div>
                        <div class="widget-subtitle">{{ $t("eventInfo.widgets.foyerMsg") }}</div>
                      </div>
                      <i class="fas fa-arrow-right"></i>
                    </el-col>

                    <el-col @click.native="openWidget('album')" :span="24" class="widget-item mt-2">
                      <div class="widget-icon">
                        <i class="fas fa-images"></i>
                      </div>
                      <div class="widget-head">
                        <div class="widget-title">{{ $t("eventInfo.widgets.album") }}</div>
                        <div class="widget-subtitle">{{ $t("eventInfo.widgets.albumMsg") }}</div>
                      </div>
                      <i class="fas fa-arrow-right"></i>
                    </el-col>

                    <el-col @click.native="openWidget('faq')" :span="24" class="widget-item mt-2">
                      <div class="widget-icon">
                        <i class="fas fa-question-circle"></i>
                      </div>
                      <div class="widget-head">
                        <div class="widget-title">{{ $t("eventInfo.widgets.faq") }}</div>
                        <div class="widget-subtitle">{{ $t("eventInfo.widgets.faqMsg") }}</div>
                      </div>
                      <i class="fas fa-arrow-right"></i>
                    </el-col>

                    <!-- <el-col :span="24" class="widget-item mt-2">
                      <div class="widget-icon">
                        <i class="fas fa-heart"></i>
                      </div>
                      <div class="widget-head">
                        <div class="widget-title">{{ $t("eventInfo.widgets.social") }}</div>
                        <div class="widget-subtitle">{{ $t("eventInfo.widgets.socialMsg") }}</div>
                      </div>
                      <div class="soon">{{ $t("eventInfo.widgets.soon") }}</div>
                    </el-col> -->

                    <!-- <el-col :span="24" class="widget-item mt-2">
                      <div class="widget-icon">
                        <i class="fas fa-poll"></i>
                      </div>
                      <div class="widget-head">
                        <div class="widget-title">{{ $t("eventInfo.widgets.vote") }}</div>
                        <div class="widget-subtitle">{{ $t("eventInfo.widgets.voteMsg") }}</div>
                      </div>
                      <div class="soon">{{ $t("eventInfo.widgets.soon") }}</div>
                    </el-col> -->

                    <!-- <el-col :span="24" class="widget-item mt-2">
                      <div class="widget-icon">
                        <i class="fas fa-chart-pie"></i>
                      </div>
                      <div class="widget-head">
                        <div class="widget-title">{{ $t("eventInfo.widgets.poll") }}</div>
                        <div class="widget-subtitle">{{ $t("eventInfo.widgets.pollMsg") }}</div>
                      </div>
                      <div class="soon">{{ $t("eventInfo.widgets.soon") }}</div>
                    </el-col> -->
                  </el-row>
                </el-col>
                <!-- <el-col :span="24" class="mt-2 d-flex justify-content-end">
                  <el-button size="medium" type="primary" @click="saveModules" :loading="loading == 'saveModules'">{{ $t("eventInfo.widgets.save") }}</el-button>
                </el-col> -->
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="'Modül ayarları'" class="medium" center modal-append-to-body destroy-on-close>
      <PageModuleUpdate :data="updateForm" @closeDialog="modalVisible = false" @deleteMe="deletePageContent" v-if="modalVisible" @updated="updateModule" />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible2" :title="$t('eventInfo.modules.moduleSettings')" class="medium" center modal-append-to-body destroy-on-close>
      <EventModuleUpdate :data="updateEventForm" @closeDialog="modalVisible2 = false" v-if="modalVisible2" @deleteMe="deleteModuleItem" @updated="updateEventModule" />
    </el-dialog>
  </div>
</template>

<script>
Date.prototype.addHours = function(h) {
  this.setHours(this.getHours() + h);
  return this;
};

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor, Quill } from "vue-quill-editor";
import QuillResize from "quill-resize-module";
Quill.register("modules/resize", QuillResize);

import axios from "axios";
import moment from "moment";
import Redirect from "@/components/Redirect";
import ifilter from "../../assets/js/imagefilter.js";
import draggable from "vuedraggable";

import PageModuleUpdate from "../../components/eventinfo/PageModuleUpdate.vue";
import EventModuleUpdate from "../../components/eventinfo/EventModuleUpdate.vue";

export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.eventHome"),
      titleTemplate: "%s | Holacon - Event Management Console"
    };
  },
  components: {
    quillEditor,

    PageModuleUpdate,
    EventModuleUpdate,
    Redirect,
    draggable,
    ifilter
  },
  name: "EventInfo",
  data() {
    return {
      updateIndex: null,
      updateEventModuleIndex: null,
      customSectionForm: {
        id: null,
        title: null,
        titleTr: null,
        name: null,
        details: null,
        iconClass: null,
        isActive: true,
        isCustom: true,
        url: null
      },
      customModuleForm: {
        id: null,
        title: "New Module",
        titleTr: "Yeni Modül",
        name: null,
        iconClass: "fas fa-plus",
        isActive: true,
        isCustom: true,
        isVisibleOnlyAttendees: false,
        url: null,
        openInApp: false,
        type: 0,
        details: null,
        detailsTr: null,
        tagIds: []
      },
      updateEventForm: null,
      loading: false,
      eventTimeout: null,
      editor: null,
      selectedDates: [],
      validationErrors: [],
      tab1Keys: ["title"],
      loading: false,
      form: JSON.parse(JSON.stringify(this.$store.state.event.event)),
      tab2Keys: ["venue", "latitude", "longtitude", "address", "country", "city"],
      venueChanged: false,
      addressChanged: false,
      axios,
      logoPercent: 0,
      coverPercent: 0,
      topBannerPercent: 0,
      bottomBannerPercent: 0,
      moment,
      editorOption: {
        modules: {
          toolbar: {
            container: [["bold", "italic", "underline", "strike"], [{ indent: "-1" }, { indent: "+1" }], [{ color: [] }, { background: [] }], ["clean"], ["link", "image", "video"]],
            handlers: {
              image: () => {
                this.selectLocalImage();
              }
            }
          },

          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          },

          resize: {
            modules: ["Resize"]
          }
        }
      },
      quillUploading: false,
      modalVisible: false,
      modalVisible2: false,
      updateForm: null,
      isFilterEnabled: false,
      isModulesDataChanged: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "questionlibrary",

      tab3Keys: "socialMedia.Website,socialMedia.facebook,socialMedia.Twitter,socialMedia.Instagram,socialMedia.LinkedIn,socialMedia.Youtube,socialMedia.Pinterest,socialMedia.GooglePlus".split(","),
      tab4Keys: "organizator.Title,organizator.PhoneNumber,organizator.Email,organizator.Email,organizator.Address",

      paymentGateway: {
        isActive: false, // entegrasyonlar bitmediği için arayüzde görünmesin diye eklendi
        login: {
          Email: "ozkan@internative.net",
          Password: "123456"
        },
        register: {
          Email: "",
          Password: "",
          PasswordRetry: ""
        },
        posList: [],
        bankList: [],
        bankParameters: [],
        addUpdatePos: {
          Id: null,
          BankId: null,
          PosParameters: []
        }
      }
    };
  },
  async created() {
    await this.$store.dispatch("getAllTimeZones");
    await this.$store.dispatch("getEventCategories");
    this.selectedDates = [this.form.startDate, this.form.endDate];
  },

  methods: {
    goUpgrade() {
      window.open(`/organisation/${this.$store.state.event.event.organizationID}/billing`, "_self");
    },
    deletePageContent() {
      this.form.webpageModules.splice(this.updateIndex, 1);
    },
    gatewayAxiosInstance() {
      return axios.create({
        baseURL: "http://192.168.1.195:25006/",
        timeout: 10000,
        headers: { Authorization: "Bearer " + this.paymentGateway.login.Token }
      });
    },
    async signInToGateway() {
      var res = await this.gatewayAxiosInstance().post("login/signin", this.paymentGateway.login);
      if (res.data.HasError) {
        this.$message.error(res.data.Message);
        return;
      }

      this.paymentGateway.login.Token = res.data.Data.Token;
      await this.listGatewayBanks();
      await this.listGatewayPoses();
    },
    async listGatewayPoses() {
      var res = await this.gatewayAxiosInstance().post("account/getmyposes", {});
      if (res.data.HasError) {
        this.$message.error(res.data.Message);
        return;
      }

      this.paymentGateway.posList = res.data.Data;
    },
    async listGatewayBanks() {
      var res = await this.gatewayAxiosInstance().get("definition/getbanks");
      if (res.data.HasError) {
        this.$message.error(res.data.Message);
        return;
      }

      this.paymentGateway.bankList = res.data.Data.Items;
    },
    deleteModuleItem(index) {
      if (index != null || index == undefined) {
        this.loading = "deleteModuleItem-" + index;
      } else {
        this.loading = "deleteModuleItem-" + updateEventModuleIndex;
      }
      if (this.eventTimeout) clearTimeout(this.eventTimeout);
      this.eventTimeout = setTimeout(() => {
        if (index != undefined || index != null) {
          this.form.modules.splice(index, 1);
        } else {
          this.form.modules.splice(this.updateEventModuleIndex, 1);
        }
        this.loading = false;
      }, 500);
    },
    async listGatewayBankParameters() {
      var res = await this.gatewayAxiosInstance().post("definition/getbankparameters", {
        Id: this.paymentGateway.addUpdatePos.BankId
      });
      if (res.data.HasError) {
        this.$message.error(res.data.Message);
        return;
      }

      this.paymentGateway.addUpdatePos.PosParameters = res.data.Data.Items;
    },
    async addUpdateGatewayPos() {
      var res = await this.gatewayAxiosInstance().post("account/addupdatepos", this.paymentGateway.addUpdatePos);
      if (res.data.HasError) {
        this.$message.error(res.data.Message);
        return;
      }

      await this.listGatewayPoses();
    },
    updateModule(item) {
      this.form.webpageModules.splice(this.updateIndex, 1, item);
      this.modalVisible = false;
    },
    updateEventModule(item) {
      // get before value
      let modulesBefore = JSON.stringify(this.form.modules);
      this.form.modules.splice(this.updateEventModuleIndex, 1, item);
      this.modalVisible2 = false;

      // check if the data has changed actually
      if (modulesBefore !== JSON.stringify(this.form.modules)) {
        this.isModulesDataChanged = true; // if changed flag
      }
    },
    newAppModule() {
      this.loading = "newAppModule";
      if (this.eventTimeout) clearTimeout(this.eventTimeout);
      this.eventTimeout = setTimeout(async () => {
        this.$message.success("Yeni modül eklenmiştir.");
        this.form.modules.push({ ...this.customModuleForm });
        this.updateEventModuleIndex = this.form.modules.length - 1;
        this.updateEventForm = JSON.parse(JSON.stringify(this.customModuleForm));
        this.modalVisible2 = true;
        this.loading = false;
      }, 500);
    },
    newModule() {
      this.loading = "newModule";
      if (this.eventTimeout) clearTimeout(this.eventTimeout);
      this.eventTimeout = setTimeout(async () => {
        this.form.webpageModules.push({ ...this.customSectionForm, title: "New Module", titleTr: "Yeni Module" });
        this.$message.success("Yeni bölüm eklenmiştir.");
        this.loading = false;
      }, 500);
    },
    async saveBasic() {
      if (this.eventTimeout) clearTimeout(this.eventTimeout);
      var startDate = new Date(new Date(new Date(this.form.startDate).getFullYear(), new Date(this.form.startDate).getMonth(), new Date(this.form.startDate).getDate()).setHours(3)).toISOString();
      var endDate = new Date(new Date(new Date(this.form.endDate).getFullYear(), new Date(this.form.endDate).getMonth(), new Date(this.form.endDate).getDate()).setHours(3)).toISOString();

      this.loading = "saveBasic";
      this.eventTimeout = setTimeout(async () => {
        var res = await this.$store.dispatch("updateEventBasicInfo", { ...this.form, startDate: startDate, endDate: endDate });
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
    async saveModules() {
      if (this.eventTimeout) clearTimeout(this.eventTimeout);
      this.loading = "saveModules";
      this.eventTimeout = setTimeout(async () => {
        var res = await this.$store.dispatch("updateEventModules", { modules: this.form.modules });
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
        // if success remove 'isModulesDataChanged' flag
        if (this.validationErrors.length === 0) this.isModulesDataChanged = false;
      }, 500);
    },
    async saveGeneral() {
      if (this.eventTimeout) clearTimeout(this.eventTimeout);
      this.loading = "saveGeneral";
      this.eventTimeout = setTimeout(async () => {
        var res = await this.$store.dispatch("updateEventGeneralSettings", this.form);
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
    async saveContact() {
      if (this.eventTimeout) clearTimeout(this.eventTimeout);
      this.loading = "saveContact";
      var location = this.form.location;
      if (location.latitude != null && location.longtitude != null) {
        location.latitude = location.latitude.toString();
        location.longtitude = location.longtitude.toString();
      }

      var form = JSON.parse(JSON.stringify(this.form));
      // https://www.twitter.com/ https://www.linkedin.com/ https://www.facebook.com/ https://www.instagram.com/ https://www.youtube.com/  https://
      if (form.socialMedia.instagram != null) {
        form.socialMedia.instagram = "https://www.instagram.com/" + form.socialMedia.instagram;
      }
      if (form.socialMedia.twitter != null) {
        form.socialMedia.twitter = "https://www.twitter.com/" + form.socialMedia.twitter;
      }
      if (form.socialMedia.linkedIn != null) {
        form.socialMedia.linkedIn = "https://www.linkedin.com/" + form.socialMedia.linkedIn;
      }
      if (form.socialMedia.facebook != null) {
        form.socialMedia.facebook = "https://www.facebook.com/" + form.socialMedia.facebook;
      }
      if (form.socialMedia.youtube != null) {
        form.socialMedia.youtube = "https://www.youtube.com/" + form.socialMedia.youtube;
      }
      if (form.socialMedia.website != null) {
        form.socialMedia.website = "https://" + form.socialMedia.website;
      }
      this.eventTimeout = setTimeout(async () => {
        var res = await this.$store.dispatch("updateEventContactInfo", { ...form, location });
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
    onEditorReady(editor) {
      editor.root.setAttribute("data-placeholder", this.$t("enterText"));
      editor.getModule("toolbar").addHandler("image", () => {
        this.selectLocalImage(editor);
      });
    },

    selectLocalImage(editor) {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.click();
      input.onchange = () => {
        const file = input.files[0];
        if (/^image\//.test(file.type)) {
          this.saveToServer(file, editor);
          this.quillUploading = "Image upload process started.";
        } else {
          //console.warn("You could only upload images.");
          this.quillUploading = "You could only upload images.";
          setTimeout(() => {
            this.quillUploading = false;
          }, 3000);
        }
      };
    },
    resetMap() {
      this.form.location.latitude = null;
      this.form.location.longtitude = null;
    },
    saveToServer(file, editor) {
      const fd = new FormData();

      fd.append("image", file);
      const xhr = new XMLHttpRequest();
      xhr.open("POST", axios.defaults.baseURL + "event/uploadImage?uploadType=html&language=" + this.$i18n.locale, true);
      xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("token"));

      xhr.onload = () => {
        if (xhr.status === 200) {
          const body = JSON.parse(xhr.responseText);
          if (body.alert.hasError == false) {
            const url = body.data.item.url;
            this.insertToEditor(url, editor);
            this.quillUploading = "Image upload process completed successfully.";
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          } else {
            this.$message.error(body.alert.message);
            this.quillUploading = body.alert.message;
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          }
        } else {
          this.quillUploading = xhr.statusText + " (Code: " + xhr.status + ")";
          setTimeout(() => {
            this.quillUploading = false;
          }, 3000);
        }
      };

      xhr.send(fd);
    },

    insertToEditor(url, editor) {
      editor.insertEmbed(editor.getSelection().index, "image", url);
    },

    svgfilter(hex) {
      return ifilter.hexfilter(hex).filter;
    },
    async publishEvent() {
      var dummy = JSON.parse(JSON.stringify(this.form.settings));
      var res = await axios.post("event/ChangeEventIsPublic", { isPublished: !dummy.isPublished });

      if (res.data.alert.hasError == true) {
        this.$message.error(res.data.alert.message);
      } else {
        this.form.settings.isPublished = res.data.data.isPublished;
        this.$message.success(res.data.alert.message);
      }
    },

    clean() {
      this.form.location.address = null;
      this.form.location.city = null;
      this.form.location.country = null;
      this.form.location.venue = null;
      this.form.location.latitude = null;
      this.form.location.longtitude = null;
    },
    openRegistration(language) {
      if (this.$store.state.event.event.settings.isOnlineRegistrationEnabled == false) {
        this.$message.warning(this.$t("closed"));
        return;
      }
      window.open("https://register.holacon.com?ApplicationID=" + this.$store.state.event.event.applicationID + "&EventID=" + this.$store.state.event.event.id + "&language=" + language, "_blank");
    },
    openRegistrationCategory(language, category) {
      if (this.$store.state.event.event.settings.isOnlineRegistrationEnabled == false) {
        this.$message.warning(this.$t("closed"));
        return;
      }
      window.open("https://register.holacon.com?ApplicationID=" + this.$store.state.event.event.applicationID + "&EventID=" + this.$store.state.event.event.id + "&language=" + language + "&categoryID=" + category, "_blank");
    },
    toggleModule(item) {
      var index = this.form.hideModules.findIndex(k => k == item.name);
      if (index != -1) {
        this.form.hideModules.splice(index, 1);
      } else {
        this.form.hideModules.push(item.name);
      }
    },
    deleteBankAccount(index) {
      this.form.bankAccounts.splice(index, 1);
    },
    addBankAccount() {
      this.form.bankAccounts.push({
        id: null,
        title: null,
        orderNO: 0,
        iban: null,
        accountHolder: null,
        accountNO: null,
        branchCode: null,
        swiftCode: null
      });
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    coverProgress(event) {
      this.coverPercent = event.percent;
    },
    topBannerProgress(event) {
      this.topBannerPercent = event.percent;
    },
    bottomBannerProgress(event) {
      this.bottomBannerPercent = event.percent;
    },
    async coverSuccess(response) {
      this.coverPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.form.image = response.data.item.url;
        await this.$store.dispatch("updateEventImage", response.data.item.url);
      }
    },
    async logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.form.logo = response.data.item.url;
        await this.$store.dispatch("updateEventLogo", response.data.item.url);
      }
    },
    topBannerSuccess(response) {
      this.topBannerPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.settings.topBanner = response.data.item.url;
      }
    },
    bottomBannerSuccess(response) {
      this.bottomBannerPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.settings.bottomBanner = response.data.item.url;
      }
    },
    placeChanged(place) {
      console.log(place);
      this.form.location.venue = place.name;
      this.form.location.address = place.formatted_address;
      this.form.location.latitude = place.geometry.location.lat();
      this.form.location.longtitude = place.geometry.location.lng();
      this.$refs.mapRef.$mapPromise.then(map => {
        map.panTo({
          lat: this.form.location.latitude,
          lng: this.form.location.longtitude
        });
      });
    },
    setCenter(event) {
      this.form.location.latitude = event.latLng.lat();
      this.form.location.longtitude = event.latLng.lng();
      this.$refs.mapRef.$mapPromise.then(map => {
        map.panTo({
          lat: this.form.location.latitude,
          lng: this.form.location.longtitude
        });
      });

      this.$geocoder.send(
        {
          lat: this.form.location.latitude,
          lng: this.form.location.longtitude
        },
        response => {
          if (response.results.length != 0) {
            document.getElementsByClassName("introInput")[0].value = response.results[0].formatted_address;
            if (this.addressChanged == false) {
              this.form.location.address = response.results[0].formatted_address;
            }
          }
        }
      );
    },
    hasError(key) {
      if (key == "tab1") {
        return this.validationErrors.some(k => this.tab1Keys.indexOf(k.key) != -1);
      }
      if (key == "tab2") {
        return this.validationErrors.some(k => this.tab2Keys.indexOf(k.key) != -1);
      }
      if (key == "tab3") {
        return this.validationErrors.some(k => this.tab3Keys.indexOf(k.key) != -1);
      }
      if (key == "tab4") {
        return this.validationErrors.some(k => this.tab4Keys.indexOf(k.key) != -1);
      }
      return false;
    },
    save() {
      this.validationErrors = [];
      this.loading = true;
      this.selectedDates = [new Date(this.selectedDates[0]).addHours(6), new Date(this.selectedDates[1])];
      axios
        .post("event/update", {
          ...this.form,
          startDate: this.selectedDates[0] || null,
          endDate: this.selectedDates[1] || null,
          location: {
            ...this.form.location,
            latitude: this.form.location.latitude != null && this.form.location.latitude != "" ? parseFloat(this.form.location.latitude).toFixed(7) : null,
            longtitude: this.form.location.longtitude != null && this.form.location.longtitude != "" ? parseFloat(this.form.location.longtitude).toFixed(7) : null
          },
          about: this.form.about != null ? this.form.about.replace(/http:/g, "https:") : null
        })
        .then(res => {
          this.validationErrors = res.data.validationErrors;
          this.loading = false;
          if (res.data.alert.hasError == true) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            this.$store.dispatch("getEvent");
          }
        });
    },
    onModulesDragUpdate() {
      // if drag changed means there are changes need to be saved
      this.isModulesDataChanged = true;
    },
    openWidget(widgetName) {
      console.log(widgetName);
      window.open("https://cdn.holacon.com/" + widgetName + "?applicationID=" + this.$store.state.event.event.applicationID + "&eventID=" + this.$store.state.event.event.id + "&lang=" + localStorage.getItem("lang"), "_blank");
    }
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    getEventCategories() {
      return this.$store.getters.getEventCategories;
    },
    getEnums() {
      return this.$store.getters.getEnums;
    },
    allTimeZones() {
      return this.$store.getters.getAllTimeZones;
    },
    getLatLng() {
      if (this.form.location.latitude == null || this.form.location.latitude == "") {
        return {
          lat: 41.0054958,
          lng: 28.8720965
        };
      }
      return {
        lat: parseFloat(this.form.location.latitude),
        lng: parseFloat(this.form.location.longtitude)
      };
    }
  },

  watch: {
    "paymentGateway.addUpdatePos.BankId": function() {
      this.listGatewayBankParameters();
    },
    "$store.state.event.event.id": function() {
      this.form = JSON.parse(JSON.stringify(this.$store.state.event.event));
    }
  }
};
</script>

<style scoped>
.card {
  padding: 20px 0px;
}

.el-color-picker {
  display: block;
}

.list-complete-item {
  display: flex;
  flex-direction: row;
}

.el-color-picker__trigger {
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 40px;
  width: 40px;
  padding: 4px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  font-size: 0;
  position: relative;
  cursor: pointer;
  display: block;
  width: 100%;
}

.module-passive {
  background: #fff !important;
  color: #333 !important;
}
</style>
<style lang="less">
.d-block {
  display: flex !important;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  b {
    color: #06658c;
    margin-left: 4px;
  }

  i {
    color: #06658c;
    margin-right: 4px;
    margin-left: 4px;
  }
}

#event-info {
  .introInput {
    background-color: #fbfbfb;
    border-radius: 8px;
    border: 0.5px solid #d6d9d9;
    color: #505763;
    font-size: 14px;
    font-weight: 400;
    height: 42px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    box-sizing: border-box;
    appearance: none;
    width: 100%;

    &:focus {
      border-color: #03658c;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      outline: 0;
    }

    &:focus-visible {
      outline: 0;
    }

    &:hover {
      border-color: #c0c4cc;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

      &:focus {
        border-color: #03658c;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        outline: 0;
      }
    }
  }
}
.profile-cover-img {
  position: relative;
  overflow: hidden;
  border-radius: 16px 16px 0px 0px;
  background: #ececec;
  aspect-ratio: 11.2/5;
  width: 100%;
  height: auto;
  background-position: center;
  background-size: cover;
  & > .upload-cover {
    position: absolute;
    gap: 0.5rem;
    transition: all 0.5s ease-in-out;
    background-color: #292f3b65;

    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    opacity: 0;
    .el-upload__tip {
      color: white !important;
    }
  }
  &:hover {
    & > .upload-cover {
      transition: all 0.5s ease-in-out;
      opacity: 1;
    }
  }
}
.profile-thumb {
  position: relative;
  background-color: white;
  border-radius: 16px;
  & > .upload-logo {
    border-radius: 16px;
    position: absolute;
    width: 120px;
    height: 120px;
    top: 0;
    text-align: center;
    transition: all 0.5s ease-in-out;
    opacity: 0;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.5);
    background-color: #292f3b65;

    .el-upload__tip {
      color: white !important;
    }
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  &:hover {
    & > .upload-logo {
      transition: all 0.5s ease-in-out;
      opacity: 1;
    }
  }
}
.modal-base-small {
  min-width: 500px;
}
</style>
<style lang="less" scoped>
.modules-grid-head {
  grid-template-columns: 30px 1fr 90px 90px;
}
.info-card {
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 16px !important;
  position: relative;

  .widget-item {
    user-select: none;
  }
  & > .el-row {
    margin-top: 16px !important;
  }
  .header {
    margin-bottom: 20px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    .title {
      display: flex;
      flex-direction: column;
      font-weight: bold;
      color: #292f3b;
      font-size: 18px;
      span {
        color: #505763;
        font-weight: 400;
        line-height: 1.3;
        font-size: 14px;
      }
    }

    .actions {
      display: block;
      .el-button-group {
        width: max-content;
      }
    }
    span {
      font-weight: 400;
    }
  }
}
.registerform-input-container {
  .el-upload {
    width: 100% !important;
  }
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    i {
      cursor: pointer;
    }
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    gap: 0.3rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
.contact-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background: #f1f1f1;
  border-radius: 8px;
  padding: 10px 8px;
  margin-bottom: 10px;
  gap: 0.5rem;

  &:last-child {
    margin-bottom: unset;
  }

  i {
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    font-size: 20px;
    color: #505763;
    margin-right: 6px;
    margin-left: 6px;
    flex-shrink: 0;
  }
  .el-input {
    flex-grow: 1;
  }
  .el-switch {
    flex-shrink: 0;
  }
  &.passive {
    background-color: #fff2f2 !important;
  }
}
.modules-grid-items-container {
  transition: all 0.5s;
  border-radius: 8px;
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  .item {
    .modules-item-title {
      display: flex;
      flex-direction: row;
      gap: 0.5rem;
      align-items: center;
      .modules-item-left {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        border: 2px solid #268ea6;
        aspect-ratio: 1;

        i {
          color: #268ea6;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      }
      .modules-item-right {
        display: flex;
        flex-direction: column;
        .modules-item-head {
          font-weight: bold;
          color: #292f3b;
        }
        .modules-item-sub-head {
          font-weight: 400;
          color: #505763;
        }
      }
    }
    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
      &.me {
        color: #ccc;
      }
    }
    padding: 10px;
    display: grid;
    transition: all 0.5s;
    border-radius: 8px;
    grid-template-columns: 30px 1fr 90px 90px;
    background-color: #f1f1f1;
    gap: 0.5rem;
    align-items: center;
    &:last-child {
      margin-bottom: unset;
    }
    &.passive {
      background-color: #fff2f2 !important;
    }
  }
}
.widget-item {
  display: grid;
  cursor: pointer;
  align-items: center;
  gap: 0.5rem;
  grid-template-columns: 40px 1fr 40px;
  .widget-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    border: 2px solid #268ea6;

    i {
      color: #268ea6;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }

  .widget-head {
    display: flex;
    flex-direction: column;
    .widget-title {
      font-weight: bold;
      color: #292f3b;
    }
    .widget-subtitle {
      font-weight: 400;
      color: #505763;
    }
  }
  border-radius: 8px;
  background-color: #f1f1f1;
  padding: 1rem !important;

  .soon {
    padding: 6px 8px;
    background: white;
    border-radius: 6px;
    color: #292f3b;
    justify-self: flex-end;
    font-weight: 500;
    word-break: keep-all !important;
  }
  & > i {
    justify-self: flex-end;
    color: #268ea6;
  }
}

.inner-alert {
  position: relative;
  min-width: auto;
  width: 100%;
  margin-right: 1rem;
  top: 0;
  left: 0;
  transform: none;
  transition: none;
  padding: 10px 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/EventInfo.vue